import { render, staticRenderFns } from "./ContextSettings.Roles.vue?vue&type=template&id=1ce20ef0&scoped=true&"
import script from "./ContextSettings.Roles.vue?vue&type=script&lang=ts&"
export * from "./ContextSettings.Roles.vue?vue&type=script&lang=ts&"
import style0 from "./ContextSettings.Roles.vue?vue&type=style&index=0&id=1ce20ef0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce20ef0",
  null
  
)

export default component.exports